// extracted by mini-css-extract-plugin
export default {"formWrapper":"AddBalanceForm_formWrapper__9K81t"};